import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MindMeschNavbar from './components/layout/MindMeschNavbar';
import { PlanProvider } from './context/PlanContext';

// Pages
import Splash from './pages/Splash';

/*
import About from './pages/About';
import Help from './pages/Help';
import Faq from './pages/Faq';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import PartnerApi from './pages/PartnerAPI';
import PartnerApiDocs from './pages/PartnerApiDocs';
import PartnerLanding from './pages/PartnerLanding';
import Benefits from './pages/Benefits';
import SubscribePage from './pages/Subscribe';
import PartnerSuccess from './pages/PartnerSuccess';
import PartnerRegister from './pages/PartnerRegister';
import PartnerPlans from './pages/PartnerPlans';
import PartnerSubscribe from './pages/PartnerSubscribe';
import PartnerLogin from './pages/PartnerLogin';
import PublicDocs from './pages/PublicDocs';
import PartnerDashboard from './pages/PartnerDashboard';
import PartnerPasswordReset from './pages/PartnerPasswordReset';
import PartnerPasswordConfirm from './pages/PartnerPasswordConfirm';
*/

function App() {
  return (
    <Router>
      <MindMeschNavbar />

      <PlanProvider>
        <Routes>

          <Route path="/" element={<Splash />} />

          {/*
          <Route path="/about" element={<About />} />
          <Route path="/help" element={<Help />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/partner-api" element={<PartnerApi />} />
          <Route path="/partnerapidocs" element={<PartnerApiDocs />} />
          <Route path="/partner" element={<PartnerLanding />} />
          <Route path="/benefits" element={<Benefits />} />
          <Route path="/subscribe" element={<SubscribePage />} />
          <Route path="/partner/success" element={<PartnerSuccess />} />
          <Route path="/partner/register" element={<PartnerRegister />} />
          <Route path="/partner/plans" element={<PartnerPlans />} />
          <Route path="/partner/subscribe" element={<PartnerSubscribe />} />
          <Route path="/partner/login" element={<PartnerLogin />} />
          <Route path="/publicdocs" element={<PublicDocs />} />
          <Route path="/partner/dashboard" element={<PartnerDashboard />} />
          <Route path="/partner/password-reset" element={<PartnerPasswordReset />} />
          <Route path="/partner/reset-confirm" element={<PartnerPasswordConfirm />} />
          */}

          <Route path="*" element={<Navigate to="/" replace />} />

        </Routes>
      </PlanProvider>
    </Router>
  );
}

export default App;